/** Common email pattern — no spaces, requires @ and a domain with TLD */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function validateEmail(
  value: string,
  options: {
    required?: boolean;
    requiredMessage?: string;
    invalidMessage?: string;
  } = {}
): string {
  const {
    required = false,
    requiredMessage = 'Email is required',
    invalidMessage = 'Invalid email address',
  } = options;
  const trimmed = value.trim();
  if (!trimmed) {
    return required ? requiredMessage : '';
  }
  if (!EMAIL_PATTERN.test(trimmed)) {
    return invalidMessage;
  }
  return '';
}
